export enum BlockedReason {
	VERSION_NOT_PUBLISHED = 'VERSION_NOT_PUBLISHED',
	PROFILE_INCOMPATIBLE = 'PROFILE_INCOMPATIBLE',
	PROFILE_GONE = 'PROFILE_GONE',
	ACCESS_GONE = 'ACCESS_GONE',
	DCREPOSITORY_REFUSED = 'DCREPOSITORY_REFUSED',
	NOT_IN_OFFER = 'NOT_IN_OFFER',
	AUTHORIZATION_PAUSED = 'AUTHORIZATION_PAUSED',
}

export type VersionSwitchModel = {
	connection_ids?: Array<number>;
};

export interface ISwitchableProjectModel {
	connection_id: number;
	data_link_id?: number;
	data_link_uuid?: string;
	data_link_label?: string;
	data_link_profile_label?: string;
	consumer_project_id?: number;
	consumer_project_label?: string;
	consumer_project_version?: string;
	current_producer_project_id?: number;
	current_producer_project_label?: string;
	current_producer_version?: string;
	switchable?: boolean;
	blocked_reason?: BlockedReason;
}

export interface IAppliedSwitch {
	connection_id?: number;
	repository_ids?: Array<number>;
	from_version_id?: number;
	to_version_id?: number;
}

export interface ISwitchVersionResponseModel {
	total_requested?: number;
	total_applied?: number;
	total_refused?: number;
	applied?: Array<IAppliedSwitch>;
	refused?: Array<ISwitchableProjectModel>;
}
